import { HttpClient } from '@angular/common/http';
import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { ExperimentResult } from 'src/app/shared/models/experimentation.model';
import { B4UService } from 'src/app/shared/services/b4u.service';
import { ExperimentationService } from 'src/app/shared/services/experimentation.service';
import { ParamService } from 'src/app/shared/services/param.service';
import { environment } from 'src/environments/environment';

declare var $: any;

@Component({
  selector: 'app-left-navigation',
  templateUrl: './left-navigation.component.html',
  styleUrls: ['./left-navigation.component.scss'],
})
export class LeftNavigationComponent implements OnInit {
  public leftNavContent: string = '';
  public banner: string = '';
  public _window: any = window;
  public displayBanner: string = '';
  public currentEnvironment: string = '';
  leftNavOptions: any;
  leftNavOptionsList: any = [];
  KEYCODE_TAB: number = 9;
  safeHtml: SafeHtml = '';
  public experimentResult: ExperimentResult | null = null;

  constructor(
    private hostElement: ElementRef,
    private http: HttpClient,
    private paramService: ParamService,
    private b4uService: B4UService,
    private sanitizer: DomSanitizer,
    private experimentationService: ExperimentationService
  ) {}

  ngOnInit(): void {
    const rand = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    this.banner = this._window['AB']['userInfo']['banner'];
    this.displayBanner = this._window['AB']['userInfo']['displayableBanner'];
    const bannerConfig = (
      environment.bannerConfiguration as { [key: string]: any }
    )[this.banner].leftNavigationUrl;
    let url = window.location.href.includes('local')
      ? `https://www-qa1.${this.banner}.com/${bannerConfig}`
      : bannerConfig;
    url = url.replace(/\{banner\}/g, this.banner);

    const htmlFetch$ = this.http.get(url, { responseType: 'text' }).toPromise().catch(() => {
      const fallbackUrl = url.replace(/\{banner\}/g, 'master');
      return this.http.get(fallbackUrl, { responseType: 'text' }).toPromise();
    });

    // Fetch left nav HTML and experiment result in parallel — both needed before rendering
    // Only needed for B2B as left nav is server-rendered for B2C and experiment is only for B2B, so safe to fetch both in same Promise.all
    Promise.all([htmlFetch$, this.experimentationService.getExperiment()])
      .then(([html, experimentResult]: [string | undefined, ExperimentResult]) => {
        this.experimentResult = experimentResult;
        if (html) {
          this.parseHtml(html, experimentResult);
        }
      })
      .catch(() => {
        // Non-critical — left nav simply won't render
      });
  }

  parseHtml(data: string, experimentResult: ExperimentResult | null = null): void {
    data = data.split('(banner)').join(this.banner);
    data = data.replace('(banner4U)', this.displayBanner);
    this.leftNavContent = data;
    const parser = new DOMParser();
    const doc = parser.parseFromString(this.leftNavContent, 'text/html');
    this.setLeftNavActiveLink(doc);
    const enableSavingsHubByBanner = this._window['SWY']?.CONFIGSERVICE?.featureToggleConfig?.enableSavingsHub;

    //remove discovery nav item for variant A and B, keep for variant C
    if (experimentResult?.isEligible && enableSavingsHubByBanner) {
      switch (experimentResult.variant) {
        case 'A':
          //Current functionality w/o discovery
          this._removeDiscoveryNavItem(doc);
          break;
        case 'B':
          //Discovery Left nav shown, home nav link points to /coupons-deals. only accessible from left nav
          this._showDiscoveryNavItem(doc);
          break;
        case 'C':
          //Discovery Left nav shown, home nav link points to /coupons-deals. only accessible from left nav
          this._showDiscoveryNavItem(doc);
          break;
        default:
          //Current functionality w/o discovery
          this._removeDiscoveryNavItem(doc);
          break;
      }
    } else {
      this._removeDiscoveryNavItem(doc);
    }

    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(doc.body.innerHTML);
  }

  public setLeftNavActiveLink(doc: Document): void {
    const navElement = doc.querySelector('.left-navigation-level__categories-tree');
    if (navElement) {
      const anchorElements = navElement.querySelectorAll('a');
      for (const anchor of Array.from(anchorElements)) {
        if ((anchor as HTMLAnchorElement).pathname === window.location.pathname) {
          (anchor as HTMLAnchorElement).classList.add('active');
          break;
        }
      }
    }
  }

  /**
   * Removes the /loyalty/discovery <li> from the parsed left nav DOM.
   * Called for variant A and B only.
   */
  private _removeDiscoveryNavItem(doc: Document): void {
      doc.querySelectorAll('li > a[href="/loyalty/discovery"]').forEach(function(link) {
        const li = link.closest('li');
        if (li) {
          li.remove();
        }
      });
  }

  private _showDiscoveryNavItem(doc: Document): void {
    doc.querySelectorAll('li > a.left-navigation-level__link[href="/loyalty/discovery"]').forEach(function(link) {
      (link as HTMLElement).style.setProperty('visibility', 'visible', 'important');
      (link as HTMLElement).style.setProperty('overflow', 'visible', 'important');
    });
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): any {
    if (window.innerWidth <= 990) {
      if (e.key === 'Tab' || e.keyCode === this.KEYCODE_TAB) {
        let focusableEls = this.hostElement.nativeElement;
        let modalContent = $(focusableEls).find(
          'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), input[type="ul"]:not([disabled]), input[type="li"]:not([disabled])'
        );
        var firstFocusableEl = modalContent.first()[0];
        var lastFocusableEl = modalContent.last()[0];

        if (e.shiftKey) {
          if (document.activeElement === firstFocusableEl) {
            lastFocusableEl.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableEl) {
            firstFocusableEl.focus();
            e.preventDefault();
          }
        }
      }
    }
  }

  ngAfterViewInit() {
    //hides safeway for you text which is not needed
    // if (window.innerWidth >= 992) {
    //   const interval = setInterval(() => {
    //     const getElementsByClass = document.getElementsByClassName(
    //       'left-navigation-level__main-text'
    //     );
    //     if (getElementsByClass && getElementsByClass.length) {
    //       for (let i = 0; i < getElementsByClass.length; i++) {
    //         getElementsByClass[i].setAttribute('style', 'display: none');
    //       }
    //       clearInterval(interval);
    //     }
    //   });
    // }

    this.observeLeftNavStaticBtn();
  }

  observeLeftNavStaticBtn(): void {
    const observer = new MutationObserver(() => {
      const leftNavStaticBtn = document.querySelector(
        'button#leftNavStaticBtn'
      );
      if (leftNavStaticBtn) {
        leftNavStaticBtn.addEventListener(
          'click',
          this.onLeftNavStaticBtnClick
        );
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: false,
    });
  }

  onLeftNavStaticBtnClick($event: Event): void {
    $event.stopPropagation();
    const dropdownElement = document.querySelector('ul.dropdown-menu');
    const leftNavStaticBtn = document.querySelector('button#leftNavStaticBtn');

    if (dropdownElement && leftNavStaticBtn) {
      leftNavStaticBtn.setAttribute(
        'aria-expanded',
        leftNavStaticBtn.getAttribute('aria-expanded') === 'true'
          ? 'false'
          : 'true'
      );
      leftNavStaticBtn.setAttribute(
        'aria-pressed',
        leftNavStaticBtn.getAttribute('aria-pressed') === 'true'
          ? 'false'
          : 'true'
      );
      leftNavStaticBtn.classList.toggle('rorateArrow');
      dropdownElement.classList.toggle('show');
    }
  }

}